import { render, staticRenderFns } from "./photoclaimGallery.pug?vue&type=template&id=705feb4b&lang=pug&external"
import script from "./photoclaimGallery.js?vue&type=script&lang=js&external"
export * from "./photoclaimGallery.js?vue&type=script&lang=js&external"
import style0 from "./photoclaimGallery.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705feb4b')) {
      api.createRecord('705feb4b', component.options)
    } else {
      api.reload('705feb4b', component.options)
    }
    module.hot.accept("./photoclaimGallery.pug?vue&type=template&id=705feb4b&lang=pug&external", function () {
      api.rerender('705feb4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photoclaimGallery/index.vue"
export default component.exports